<template>
    <div style="display: flex">

        <a
            class="btn btn-sm btn-clean btn-icon btn-icon-sm"
            title="جزئیات"
            @click="openModalDetails(row.id)"
        >
            <i class="fa fa-info"></i>
        </a>
        <a
            v-if="$can('change-setting', 'accounting')"
            class="btn btn-sm btn-clean btn-icon btn-icon-sm"
            @click.prevent="openModal"
            title="آپدیت وضعیت مغایرت"
        >
            <i class="fas fa-cog"></i>
        </a>
        <a
            v-if="$can('change-setting', 'accounting')"
            class="btn btn-sm btn-clean btn-icon btn-icon-sm"
            @click.prevent="calculateDiscrepancies"
            title="درخواست مجدد بررسی مغایرت"
        >
            <i class="fa fa-sync"></i>
        </a>

        <!-- Detail Modal -->
        <div :id="`detail_modal_${row.id}`" class="modal fade" role="dialog">
            <div class="modal-dialog row justify-content-center">
                <div class="modal-content">
                    <div class="modal-body mb-4">
                        <div class="modal-header">
                            <h4 class="modal-title">جزئیات مغایرت {{ row.id }}</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="mb-2">
                            <div class="row my-2 bg-white p-1">

                                <div class="col-12 my-2 d-flex justify-content-between">
                                    <div class="text-left"> موجودی مورد انتظار </div>
                                    <div dir="ltr">{{ row.expected_balance }}</div>
                                </div>
                                <div class="col-12 my-2 d-flex justify-content-between">
                                    <div class="text-left"> موچودی واقعی </div>
                                    <div dir="ltr">{{ row.actual_balance }}</div>
                                </div>
                                <div class="col-12 my-2 d-flex justify-content-between">
                                    <div class="text-left"> تعداد مورد انتظار </div>
                                    <div>{{ row.expected_count }}</div>
                                </div>
                                <div class="col-12 my-2 d-flex justify-content-between">
                                    <div class="text-left"> تعداد واقعی </div>
                                    <div>{{ row.actual_count }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal for updating discrepancy statuses -->
        <div v-if="isModalVisible" class="modal-overlay">
            <div class="modal-content small-modal">
                <div class="modal-header">
                    <h5 class="modal-title">
                        {{ $t("accounting.label.update_balance_discrepancy_status") }}
                    </h5>
                    <button class="modal-close" @click="closeModal">&times;</button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="changeDiscrepancyStatus">
                        <div class="form-row">
                            <!-- Count Discrepancy -->
                            <div class="form-group">
                                <label for="count_discrepancy_status">
                                    {{ $t("accounting.label.select_count_discrepancy_status") }}
                                </label>
                                <select
                                    size="1"
                                    id="count_discrepancy_status"
                                    class="form-control"
                                    v-model="selectedCountDiscrepancy"
                                >
                                    <option
                                        v-for="(status, key) in COUNT_DISCREPANCY_STATUSES"
                                        :key="key"
                                        :value="key"
                                    >
                                        {{ status }}
                                    </option>
                                </select>
                            </div>

                            <!-- Balance Discrepancy -->
                            <div class="form-group">
                                <label for="balance_discrepancy_status">
                                    {{ $t("accounting.label.select_balance_discrepancy_status") }}
                                </label>
                                <select
                                    size="1"
                                    id="balance_discrepancy_status"
                                    class="form-control"
                                    v-model="selectedBalanceDiscrepancy"
                                >
                                    <option
                                        v-for="(status, key) in BALANCE_DISCREPANCY_STATUSES"
                                        :key="key"
                                        :value="key"
                                    >
                                        {{ status }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-primary btn-block">
                            {{ $t("accounting.label.save_discrepancy_status") }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import toastr from "toastr";
import {accountingService, starShopAccountingService} from "@/common/api.service";
import { i18n } from "@/plugins/i18n";
import Button from "@/components/elements/button.vue";

export default Vue.extend({
    components: {Button},
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },
    data() {
        return {
            isModalVisible: false,
            sekectedDiscrepancyId: null,
            selectedCountDiscrepancy: null,
            selectedBalanceDiscrepancy: null,
            COUNT_DISCREPANCY_STATUSES: {
                1: i18n.t("accounting.discrepancies.count_discrepancy"),
                2: i18n.t("accounting.discrepancies.no_count_discrepancy"),
            },
            BALANCE_DISCREPANCY_STATUSES: {
                1: i18n.t("accounting.discrepancies.balance_discrepancy"),
                2: i18n.t("accounting.discrepancies.no_balance_discrepancy"),
            },
        };
    },
    computed: {
      activeService() {
        return this.$route.path.includes('pf') ? accountingService : starShopAccountingService;
      },
      toastr() {
        toastr.options = {
          closeButton: true,
          positionClass: "toast-bottom-center",
          preventDuplicates: false,
          rtl: false
        }

        return toastr
      },
    },
    methods: {
        openModalDetails(id) {
            $(`#detail_modal_${id}`).modal('show')
        },
        openModal() {
            this.isModalVisible = true;
            this.selectedCountDiscrepancy = this.row.count_discrepancy_code;
            this.selectedBalanceDiscrepancy = this.row.balance_discrepancy_code;
        },
        closeModal() {
            this.isModalVisible = false;
        },

        changeDiscrepancyStatus() {
            const payload = {
                hashid: this.row.id,
                count_discrepancy_status: parseInt(this.selectedCountDiscrepancy),
                balance_discrepancy_status: parseInt(this.selectedBalanceDiscrepancy),
            };

            this.activeService.updateDiscrepancyStatus(payload).then(
                (response) => {
                    this.toastr.success(response.data.message);
                    // this.$refs.discrepancyStatusData.reload();
                    this.datatable.reload()
                    this.closeModal();
                },
                (error) => {
                    this.toastr.error(
                        error.response.data.message || i18n.t("message.an_error_occurred")
                    );
                }
            );
        },
        calculateDiscrepancies(e) {
          this.activeService.calculateDiscrepancies(this.row.id).then(
                (response) => {
                    this.toastr.success(response.data.message);
                    this.datatable.reload();
                },
                (error) => {
                    this.toastr.error(
                        error.response.data.message || i18n.t("message.an_error_occurred")
                    );
                }
            );
        },
    },
});
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 15px;
    border-radius: 6px;
    width: 90%;
    max-width: 350px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-close {
    cursor: pointer;
    font-size: 15px;
    background: none;
    border: none;
    font-weight: bold;
}

.form-row {
    display: flex;
    justify-content: space-between;
    gap: 15px;
}

.form-group {
    display: flex;
    flex-direction: column;
    flex: 1;
}

label {
    margin-bottom: 5px;
    white-space: nowrap;
}

select.form-control {
    width: 100%;
}

button.btn-block {
    width: 100%;
}
</style>